<script setup lang="ts">
import { useTheme } from '@/pds/composables/useTheme';
import PdsIcon from './PdsIcon.vue';

const { theme, setTheme } = useTheme();
</script>

<template>
  <div
    class="flex h-12 shrink-0 items-center rounded-[24px] border border-[#39414f] bg-[#14171c] p-1"
    role="group"
    aria-label="Thème"
  >
    <button
      type="button"
      class="flex h-10 cursor-pointer items-center gap-2 rounded-[20px] pr-[18px] pl-4 text-[14px] leading-[1.4] font-semibold"
      :class="
        theme === 'light' ? 'bg-[#f4f6f8] text-[#14171c]' : 'text-[#9aa6b8]'
      "
      :aria-pressed="theme === 'light'"
      @click="setTheme('light')"
    >
      <PdsIcon name="sun" :size="20" />
      Clair
    </button>
    <button
      type="button"
      class="flex h-10 cursor-pointer items-center gap-2 rounded-[20px] pr-[18px] pl-4 text-[14px] leading-[1.4] font-semibold"
      :class="
        theme === 'dark' ? 'bg-[#f4f6f8] text-[#14171c]' : 'text-[#9aa6b8]'
      "
      :aria-pressed="theme === 'dark'"
      @click="setTheme('dark')"
    >
      <PdsIcon name="moon" :size="20" />
      Sombre
    </button>
  </div>
</template>
